import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Loginservices } from '../login/login.services';

@Injectable()
export class LayoutgaurdGuard  {

  constructor(private _router: Router,private loginservice:Loginservices ) {
    
  }
  canActivate(): boolean {
    const userdata = this.loginservice.getLoggeduser();
    
     if(userdata!==undefined&& userdata.token!==undefined){
        return true
    }
    else{
      this._router.navigate(['/login']);
      return false;
    }
  }
}
